import { Collapse, FormControlLabel, Radio, styled, useTheme } from "@mui/material";
import { PropsWithChildren } from "react";
import { SenecCard } from "src/components/cards/base/SenecCard";
import { RadioButtonOnIcon, RadioOffIcon } from "src/foundations/icons";
import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export interface SenecRadioCardProps {
    "data-testid"?: string;
    label: string;
    collapse?: boolean;
    value: unknown;
    disabled?: boolean;
}

export const SenecRadioCard = ({
    "data-testid": dataTestId,
    label,
    collapse = false,
    value,
    disabled = false,
    children,
}: PropsWithChildren<SenecRadioCardProps>) => {
    const theme: SenecFPPTheme = useTheme();

    return (
        <SenecCard sx={{ width: "100%" }} data-testid={dataTestId}>
            <StyledFormControlLabel
                labelPlacement="start"
                label={label}
                control={
                    <Radio
                        value={value}
                        checkedIcon={<RadioButtonOnIcon />}
                        icon={<RadioOffIcon sx={{ color: theme.palette.neutralGray00.main }} />}
                        disabled={disabled}
                    />
                }
            />
            <Collapse in={collapse} data-testid={`${dataTestId}-collapse`}>
                {children}
            </Collapse>
        </SenecCard>
    );
};

const StyledFormControlLabel = styled(FormControlLabel)(() => ({
    height: "20px",
    display: "flex",
    justifyContent: "space-between",
    marginLeft: 0,
}));
